import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const ButtonFL = ({
    variant = 'contained',
    textColor = 'var(--button-text-color)',
    component = null,
    bgcolor = 'var(--primary-color)',
    bgColorHover = 'var(--primary-light-color)',
    type = 'button',
    textKey,
    keyPrefix,
    to = null,
    onClick = null,
    buttonDisabled,
    startIcon = null,
    endIcon = null,
    children,
}) => {
    const { t } = useTranslation('translation', { keyPrefix });

    const buttonComponent = to ? Link : component;

    const buttonStyles = {
        textTransform: 'none',
        bgcolor: bgcolor,
        '&:hover': { bgcolor: bgColorHover, color: textColor },
        color: textColor,
    };

    return (
        <>
            <Button
                variant={variant}
                disabled={buttonDisabled}
                type={type}
                fullWidth
                sx={buttonStyles}
                to={to}
                onClick={onClick}
                startIcon={startIcon}
                endIcon={endIcon}
                component={buttonComponent}
            >
                {t(textKey)}
                {children}
            </Button>
        </>
    );
};
